import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import DropdownComponent from '@prisjakt/ui-dropdown-new';
import CountryFlagComponent from '@prisjakt/ui-country-flag';

const buttonHeight = '40px';

export const Sites = styled.ul`
  list-style: none;
  width: 100%;
  margin-bottom: ${layout.spacing.xSmall};
  line-height: unset;
`;

export const Site = styled.li`
  transition: background ${layout.animations.buttonTransition};

  &:hover {
    background: ${p => p.theme.dropdowns.primary.hoverBackground};
  }
`;

export const Link = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${layout.spacing.xSmall};
`;

export const CountryPicker = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${layout.spacing.xSmall};
  width: 100%;
  text-align: unset;
`;

export const CountryNameWrapper = styled.div`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  line-height: 1.75;

  &:active {
    color: ${p => p.theme.text.primary};
  }
`;

export const CountryFlag = styled(CountryFlagComponent)`
  margin-right: ${layout.spacing.xSmall};
`;

export const CountryName = styled.span`
  font-weight: 600;
`;

export const Dropdown = styled(DropdownComponent)`
  max-height: ${buttonHeight};
`;
